import request from '../axios'
import requestSec from '../axiosSec'

// 退出登录
export const logout = data => request({
	url: 'sys/login/logout',
	method: 'post',
	data: data
})

// 登出企业（登出账号）
export const loginOut = data => request({
	url: 'sys/login/out',
	method: 'post',
	data: data
})

// 获取统一登录的token
export const getToken = data => request({
	url: 'sys/login/ticketLogin',
	method: 'post',
	data: data,
})

export const sysSysmenuNav = params => request({
	url: 'sys/sysmenu/nav',
	method: 'get',
	params: params
})

// 获取用户信息
export const getInfo = params => request({
	url: 'sys/login/getInfo',
	method: 'get',
	params: params,
})

// 获取用户信息 替代接口 20260226
export const getInfoProject = params => request({
	url: 'sys/login/getInfo/project',
	method: 'get',
	params: params,
})

// 获取账号信息
export const sysuserInfo = params => request({
	url: 'sys/sysuser/info',
	method: 'get',
	params: params,
})

// 文件上传 头像(所有附件上传接口)
export const fileUploadFile = data => request({
	url: 'sys/file/upload/file',
	method: 'post',
	data: data
})

// 服务站详情--附件上传接口
export const fileUploadFileServiceStation = data => request({
	url: 'sys/file/upload/file/service/station',
	method: 'post',
	data: data
})

// 修改账号信息
export const sysuserUpdate = data => request({
	url: 'sys/sysuser/update',
	method: 'post',
	data: data
})

// 获取实名认证信息
export const sysuserCompanyInfo = params => request({
	url: 'sys/sysuser/companyInfo',
	method: 'get',
	params: params,
})

// 获取收支明细
export const sysuserOrderList = data => request({
	url: 'sys/sysuser/order/list',
	method: 'post',
	data: data
})

// 获取产品
export const sysuserProductList = params => request({
	url: 'sys/sysuser/productList',
	method: 'get',
	params: params,
})

// 下载订单明细
// export const orderDownLoad = data => request({
// 	url: 'sys/sysuser/order/downLoad',
// 	method: 'post',
// 	data: data,
// 	responseType: 'blob'
// })

// 下载订单明细
export const orderDetailDownload = data => request({
	url: 'sys/sysuser/order/detail/download',
	method: 'post',
	data: data,
	responseType: 'blob'
})

// 获取订单详情数据
export const orderDetail = params => request({
	url: 'sys/sysuser/order/detail',
	method: 'get',
	params: params,
})

// 设置/修改二级密码
export const sysuserUpdateSecondPassword = data => request({
	url: 'sys/sysuser/updateSecondPassword',
	method: 'post',
	data: data
})

// 检查二级密码是否生效
export const homesearchCheckFree = params => request({
	url: 'home/homesearch/checkFree',
	method: 'get',
	params: params,
})

// 获取安全设置信息
export const configusersafeInfo = params => request({
	url: 'config/configusersafe/info',
	method: 'get',
	params: params,
})

// 修改安全设置信息
export const configusersafeInfoUpdate = data => request({
	url: 'config/configusersafe/update',
	method: 'post',
	data: data
})

// 获取在线设备数量
export const loginOnlineNum = params => request({
	url: 'sys/login/onlineNum',
	method: 'get',
	params: params,
})

// 下线登录状态
export const loginLogoutOther = params => request({
	url: 'sys/login/logout/other',
	method: 'get',
	params: params,
})

// 注销账号
export const sysuserCancelAccountCancel = data => request({
	url: 'sys/sysuser/cancelAccount/cancel',
	method: 'post',
	data: data
})

// 更换密码
export const sysuserUpdatePassword = data => request({
	url: 'sys/sysuser/updatePassword',
	method: 'post',
	data: data
})

// 首页搜索框
export const homeSearchSearch = params => request({
	url: 'home/search/search',
	method: 'get',
	// 输入的是[这个字符，后端tomcat服务器不做url会直接拒绝掉 需对参数做url编码 20260226修改
	params: {
		...params,
		keyword: params.keyword ? encodeURIComponent(params.keyword) : ''
	}
})

// 首页搜索框-执行命令
export const homeSearchCheckSearch = params => request({
	url: 'home/search/checkSearch',
	method: 'get',
	params: params,
})

// 获取导出队列--导出列表
export const sysexportList = params => request({
	url: 'sys/sysexport/list',
	method: 'get',
	params: params,
})

// 获取导出队列--获取渠道
export const sysexportChannelList = params => request({
	url: 'sys/sysexport/channelList',
	method: 'get',
	params: params,
})

// 获取导出队列--重新下载
export const sysexportReDownload = (data, type) => request({
	url: 'sys/sysexport/reDownload',
	method: 'post',
	data: data,
	responseType: 'blob'
})

// 获取导出队列--获取进度
export const sysexportProgress = data => request({
	url: 'sys/sysexport/progress',
	method: 'post',
	data: data
})

// 获取自定义配置
export const configuserpersonalizedInfo = params => request({
	url: 'config/configuserpersonalized/info',
	method: 'get',
	params: params,
})

// 编辑自定义配置
export const configuserpersonalizedUpdate = data => request({
	url: 'config/configuserpersonalized/update',
	method: 'post',
	data: data,
})

// 获取全部的收藏的菜单
export const corecollectListAll = params => request({
	url: 'core/corecollect/listAll',
	method: 'get',
	params: params,
})

// 收藏或取消收藏菜单
export const corecollectCollectOrCancel = params => request({
	url: 'core/corecollect/collectOrCancel',
	method: 'get',
	params: params,
})

// 查看电子签名/工作证
export const sysusercertificateInfo = params => request({
	url: 'sys/sysusercertificate/info',
	method: 'get',
	params: params,
})

// 上传电子签名/工作证
export const sysusercertificateSave = data => request({
	url: 'sys/sysusercertificate/save',
	method: 'post',
	data: data,
})

// 文件下载（通用性接口）
export const fileDownloadFile = params => request({
	url: 'sys/file/downloadFile',
	method: 'get',
	params: params,
	responseType: 'arraybuffer' // 设置响应类型为二进制流
})

// 获取上传队列
export const sysimportList = params => request({
	url: 'sys/sysimport/list',
	method: 'get',
	params: params,
})

// 获取上传进度
export const sysimportProgress = data => request({
	url: 'sys/sysimport/progress',
	method: 'post',
	data: data,
})

// 获取上传渠道
export const sysimportChannelList = params => request({
	url: 'sys/sysimport/channelList',
	method: 'get',
	params: params,
})

// 通用上传前置保存
export const sysimportUploadPrepose = data => request({
	url: 'sys/sysimport/uploadPrepose',
	method: 'post',
	data: data,
})

// 更新文件上传进度
export const sysimportUpdatePrepose = data => request({
	url: 'sys/sysimport/updatePrepose',
	method: 'post',
	data: data,
})

// 上传队列--查看地址--判断是否可以跳转
export const sysimportCheckJump = params => request({
	url: 'sys/sysimport/checkJump',
	method: 'get',
	params: params,
})

// 获取缓存状态 
export const cacheGetCacheType = params => request({
	url: 'cache/cache/getCacheType',
	method: 'get',
	params: params,
})

// 更新缓存（确认已经缓存）
export const cacheUpdateCacheType = params => request({
	url: 'cache/cache/updateCacheType',
	method: 'get',
	params: params,
})

// 查询搜索历史和最近访问
export const homesearchList = params => request({
	url: 'home/homesearch/list',
	method: 'get',
	params: params,
})

// 清除搜索历史和最近访问
export const homesearchRemoveAll = params => request({
	url: 'home/homesearch/removeAll',
	method: 'get',
	params: params,
})

// url文件下载开始接口
export const fileDownloadFileUrl = params => request({
	url: 'sys/file/downloadFileUrl',
	method: 'get',
	params: params
})

// url文件下载结束接口
export const fileUpdateExportStatus = params => request({
	url: 'sys/file/updateExportStatus',
	method: 'get',
	params: params
})

// 更新上传的跳转路径
export const sysimportUpdateSkipParameter = data => request({
	url: 'sys/sysimport/updateSkipParameter',
	method: 'post',
	data: data,
})

// 获取当前登录人所在组织的基本信息
export const syscompanyorganizationCompanyOrganizationInfo = params => request({
	url: 'sys/syscompanyorganization/companyOrganizationInfo',
	method: 'get',
	params: params
})

// 保存详情页路径缓存
export const globalCacheSave = data => request({
	url: 'global/cache/save',
	method: 'post',
	data: data,
})

// 查询详情页路径缓存
export const globalCacheQuery = params => request({
	url: 'global/cache/query',
	method: 'get',
	params: params
})

// 删除详情页路径缓存
export const globalCacheDelete = params => request({
	url: 'global/cache/delete',
	method: 'get',
	params: params
})

// 设置当前所在位置(点击菜单时删除对应的详情路径缓存数据)
export const globalCacheSaveWhereNow = params => request({
	url: 'global/cache/saveWhereNow',
	method: 'get',
	params: params
})

// 微信绑定
export const sysuserWxAuthentication = data => request({
	url: 'sys/sysuser/wxAuthentication',
	method: 'post',
	data: data,
})

// 首页项目追踪数据获取
export const homesearchHomeProjectTrack = params => request({
	url: 'home/homesearch/homeProjectTrack',
	method: 'get',
	params: params
})

// 首页服务站数据获取
export const homesearchTopNuminfo = params => request({
	url: 'home/homesearch/topNuminfo',
	method: 'get',
	params: params
})

// 获取基础功能数据
export const homesearchBaseInfo = params => request({
	url: 'home/homesearch/baseInfo',
	method: 'get',
	params: params
})

// 获取我的档案/设备/报销记录数据
export const homesearchAboutMeArchive = params => request({
	url: 'home/homesearch/aboutMeArchive',
	method: 'get',
	params: params
})

// 首页可视修改
export const configusersafeUpdateHomeShow = data => request({
	url: 'config/configusersafe/updateHomeShow',
	method: 'post',
	data: data,
})

// 根据父级菜单ID获取可展示的子集菜单（左侧导航菜单）
export const sysmenuMenuList = params => request({
	url: 'sys/sysmenu/menuList',
	method: 'get',
	params: params
})

// 获取是否有菜单的访问的权限
export const sysmenupowerPowerIn = params => request({
	url: 'sys/sysmenupower/powerIn',
	method: 'get',
	params: params
})

// 顶部菜单动态返回（右上角）
export const sysmenupowerDynamicMenu = params => request({
	url: 'sys/sysmenupower/dynamicMenu',
	method: 'get',
	params: params
})

// 根据token删除全部缓存标记（有弹窗后直接清除新账号对应的缓存 防止停留在旧帐号的数据中）
export const cacheDeleteCacheByToken = params => request({
	url: 'global/cache/deleteCacheByToken',
	method: 'get',
	params: params
})
